import React, { useEffect, useState } from "react";
import StyledInput from "../../components/styleInput";
import "./styles.css";
import Button from "../../components/common/button";
import BackArrow from "../../images/backArrow2.svg";
import RightArrow from "../../images/right-arrow.svg";
import notAddedBadge from "../../images/Badge.svg";
import RightArrowActive from "../../images/right-arrow-active.svg";
import NoRestStop from "../../images/NoRestStop.svg";
import ListView from "../../components/common/listView";
import { connect } from "react-redux";
import { fetchCities } from "../../components/citySearchAutoComplete/actions";
import { fetchServices } from "../deals/actions";
import AddRestStops from "../../components/AddStops";
import {
  assignRestStops,
  deleteRestStop,
  fetchPopularStops,
  getMMIKey,
  getPickupPoints,
} from "./actions";
import deleteIcon from "../../images/delete.svg";
import location from "../../images/locationBlack.svg";
import infoIcon from "../../images/infoIcon.svg";
import swap from "../../images/swap.svg";
import { time } from "ag-charts-community";
import Popup from "../../components/Popup";
import { forEach } from "lodash";

const AddCitiesAndService = (props) => {
  const [sourceValue, setSourceValue] = useState("");
  const [destinationValue, setDestinationValue] = useState("");
  const [sourceValueSelected, setSourceValueSelected] = useState(false);
  const [destinationValueSelected, setDestinationValueSelected] =
    useState(false);
  const [activeServiceId, setActiveServiceId] = useState("");
  const [showRestStopHome, setShowRestStopHome] = useState(true);
  const [showRestStopAdd, setShowRestStopAdd] = useState(false);
  const [assignedStops, setAssignedStops] = useState([]);
  const [showPostAssigned, setShowPostAssigned] = useState(false);

  const [selectedDay, setSelectedDay] = useState("-1");
  const [selectedTime, setSelectedTime] = useState("-1");
  const [selectedDuration, setSelectedDuration] = useState("-1");
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [journeyDays, setJourneyDays] = useState(1);

  const setSourceCity = (e) => {
    setSourceValue(e);
    if (!destinationValueSelected) {
      setDestinationValue("");
    }
    if (e === "") {
      setSourceValueSelected(false);
    }
    if (e) {
      props.fetchCities(e);
    }
  };
  const setDestinationCity = (e) => {
    setDestinationValue(e);
    if (!sourceValueSelected) {
      setSourceValue("");
    }
    if (e === "") {
      setDestinationValueSelected(false);
    }
    if (e) {
      props.fetchCities(e);
    }
  };

  const closeAllInput = (e) => {
    if (!sourceValueSelected) {
      setSourceValue("");
    }
    if (!destinationValueSelected) {
      setDestinationValue("");
    }
  };

  useEffect(() => {
    props.getMMIKey();
  }, []);

  useEffect(() => {
    const { assignStopSuccess } = props;
    if (assignStopSuccess && assignStopSuccess.message) {
      props.fetchServices({
        paytm_src_id: `${sourceValue.city_id}`,
        paytm_dest_id: `${destinationValue.city_id}`,
        is_round_trip: false,
        include_via_routes: false,
        rest_stops: true,
      });
    }
  }, [props.assignStopSuccess]);

  useEffect(() => {
    const { routeServices } = props;
    const activeService = routeServices.find(
      (item) => item.id === activeServiceId
    );
    if (
      activeService &&
      activeService.rest_stops &&
      activeService.rest_stops.length
    ) {
      const updatedStops = activeService.rest_stops.map((stop) => ({
        ...stop,
        isAlreadyAdded: true,
      }));
      setAssignedStops(updatedStops);
      if (showSubmitButton) {
        setShowSubmitButton(false);
      }
    }
  }, [props.routeServices]);

  const handleServiceClick = (item) => {
    setActiveServiceId(item.id);
    item.journey_days > 0
      ? setJourneyDays(Number(item.journey_days) + 1)
      : setJourneyDays(1);
    let query = {
      src: sourceValue.city_id,
      dest: destinationValue.city_id,
    };
    props.fetchPopularStops(query);
    if (item.rest_stops.length) {
      item.rest_stops.forEach((item) => {
        item.isAlreadyAdded = true;
      });
      setShowRestStopHome(false);
      setShowRestStopAdd(false);
      setShowPostAssigned(true);
      setShowSubmitButton(false);
      setAssignedStops(item.rest_stops);
    } else {
      setShowRestStopHome(true);
      setShowRestStopAdd(false);
      setShowPostAssigned(false);
      setAssignedStops([]);
    }
  };

  const handleDayChange = (item, value) => {
    let updatedStops = [];
    if (item.place_name) {
      updatedStops = assignedStops.map((stop) =>
        stop.place_name === item.place_name &&
        stop.place_address === item.place_address
          ? { ...stop, day: value }
          : stop
      );
    } else {
      updatedStops = assignedStops.map((stop) =>
        stop.name === item.name && stop.address === item.address
          ? { ...stop, day: value }
          : stop
      );
    }
    setSelectedDay(value);
    setAssignedStops(updatedStops);
    if (showSubmitButton === false) {
      setShowSubmitButton(true);
    }
  };
  const handleTimeChange = (item, value) => {
    let updatedStops = [];
    if (item.place_name) {
      updatedStops = assignedStops.map((stop) =>
        stop.place_name === item.place_name &&
        stop.place_address === item.place_address
          ? { ...stop, time: value }
          : stop
      );
    } else {
      updatedStops = assignedStops.map((stop) =>
        stop.name === item.name && stop.address === item.address
          ? { ...stop, time: value }
          : stop
      );
    }
    setSelectedTime(value);
    setAssignedStops(updatedStops);
    if (showSubmitButton === false) {
      setShowSubmitButton(true);
    }
  };

  const handleDurationChange = (item, value) => {
    let updatedStops = [];
    if (item.place_name) {
      updatedStops = assignedStops.map((stop) =>
        stop.place_name === item.place_name &&
        stop.place_address === item.place_address
          ? { ...stop, duration: value }
          : stop
      );
    } else {
      updatedStops = assignedStops.map((stop) =>
        stop.name === item.name && stop.address === item.address
          ? { ...stop, duration: value }
          : stop
      );
    }

    setSelectedDuration(value);
    setAssignedStops(updatedStops);
    if (showSubmitButton === false) {
      setShowSubmitButton(true);
    }
  };

  const prepareStopsData = () => {
    let stopsList = [];
    assignedStops.map((stop) => {
      let tempStop = {};
      if (stop.id) {
        tempStop.rest_stop_id = stop.id;
      }
      tempStop.day = Number(stop.day);
      tempStop.time = Number(stop.time);
      tempStop.duration = Number(stop.duration);
      if (!stop.id) {
        tempStop.rest_stop_id = "";
        tempStop.new_rest_stop_details = {
          name: stop.place_name || stop.name,
          address: stop.place_address || stop.address,
          lat: `${stop.latitude}` || `${stop.lat}`,
          long: `${stop.longitude}` || `${stop.long}`,
        };
      }
      stopsList.push(tempStop);
    });
    return stopsList;
  };

  const onSubmitClick = () => {
    for (let stop of assignedStops) {
      if (stop.day == null || stop.duration == null || stop.time == null) {
        alert("Each stop must have day, duration, and time before submitting.");
        return;
    }
    }
    setShowSubmitPopup(true);
  };

  const onFinalSubmitClick = () => {
    let payload = {};
    payload.paytm_src_id = `${sourceValue.city_id}`;
    payload.paytm_dest_id = `${destinationValue.city_id}`;
    payload.route_time_id = `${activeServiceId}`;
    payload.rest_stops = prepareStopsData();
    props.assignRestStops(payload);
    setShowSubmitPopup(false);
  };

  const onDeleteClick = (item) => {
    if (window.confirm(`Are you sure you want to delete ${item.name}`)) {
      let updatedStops;
      if (!item.id) {
        updatedStops = assignedStops.filter(
          (stop) =>
            stop.place_name !== item.place_name ||
            stop.place_address !== item.place_address
        );
      } else {
        updatedStops = assignedStops.filter((stop) => stop.id !== item.id);
      }
      setAssignedStops(updatedStops);
      if (item.isAlreadyAdded) {
        let data = {
          paytm_src_id: `${sourceValue.city_id}`,
          paytm_dest_id: `${destinationValue.city_id}`,
          service_id: activeServiceId,
          rest_stop_id: item.id,
        };
        props.deleteRestStop(data);
        props.fetchServices({
          paytm_src_id: `${sourceValue.city_id}`,
          paytm_dest_id: `${destinationValue.city_id}`,
          is_round_trip: false,
          include_via_routes: false,
          rest_stops: true,
        });
      }
      if (updatedStops.length === 0) {
        setShowPostAssigned(false);
        setShowRestStopHome(true);
      }
    }
  };

  const onShowMapClick = (item) => {
    let updatedStops = assignedStops.map((stop) => {
      return { ...stop, isHighlight: false };
    });
    updatedStops = updatedStops.map((stop) => {
      const hasPlaceName = stop.place_name && item.place_name;
      const isPlaceMatch =
        hasPlaceName &&
        stop.place_name === item.place_name &&
        stop.place_address === item.place_address;

      const isIdOrNameMatch =
        stop.id === item.id ||
        (stop.name === item.name && stop.address === item.address);

      if (isPlaceMatch || isIdOrNameMatch) {
        return { ...stop, isHighlight: true };
      }

      return stop;
    });

    setAssignedStops(updatedStops);
    setShowRestStopHome(false);
    setShowRestStopAdd(true);
    setShowPostAssigned(false);
  };

  const RenderServiceList = () => {
    return (
      <div className="serviceListPanel">
        <div className="serviceListContainer">
          <h3 style={{ margin: "22px 0 10px 30px" }}>
            Services from {sourceValue.city_name} to{" "}
            {destinationValue.city_name}
          </h3>
          {props.routeServices &&
            props.routeServices.map((item) => {
              if (!item.rest_stops) {
                return;
              } else {
                return (
                  <div
                    onClick={() => {
                      handleServiceClick(item);
                    }}
                    className={`serviceNameContainer ${
                      activeServiceId === item.id ? "activeBorder" : ""
                    }`}
                  >
                    <p
                      className={`serviceName ${
                        activeServiceId === item.id ? "activeColor" : ""
                      }`}
                    >
                      {item.name}
                    </p>
                    <div className="serviceRight">
                      {item.rest_stops.length === 0 ? (
                        <img
                          src={notAddedBadge}
                          alt="not added"
                          style={{ marginRight: 20 }}
                        />
                      ) : null}
                      {activeServiceId === item.id ? (
                        <img
                          src={RightArrowActive}
                          alt="Right arrow"
                          style={{ marginRight: 20 }}
                        />
                      ) : (
                        <img
                          src={RightArrow}
                          alt="Right arrow"
                          style={{ marginRight: 20 }}
                        />
                      )}
                    </div>
                  </div>
                );
              }
            })}
        </div>
      </div>
    );
  };

  const addMoreClicked = () => {
    setShowPostAssigned(false);
    setShowRestStopAdd(true);
  };

  const generateTimeOptions = () => {
    const options = [];
    let hour = 0;
    let minute = 0;

    for (let i = 1; i <= 96; i++) {
      let hourFormatted = hour < 10 ? `0${hour}` : hour;
      let minuteFormatted = minute < 10 ? `0${minute}` : minute;
      let valueString = `${hourFormatted}${minuteFormatted}`;

      let displayHour = hour % 12 === 0 ? 12 : hour % 12;
      let period = hour < 12 ? "AM" : "PM";
      let minuteDisplayFormatted = minute < 10 ? `0${minute}` : minute;
      let timeString = `${displayHour}:${minuteDisplayFormatted} ${period}`;

      options.push(
        <option key={i} value={valueString}>
          {timeString}
        </option>
      );

      minute += 15;
      if (minute === 60) {
        minute = 0;
        hour += 1;
      }
    }

    return options;
  };

  const generateIntervalOptions = () => {
    const options = [];

    for (let i = 1; i <= 12; i++) {
      const interval = i * 5;
      options.push(
        <option key={interval} value={interval}>{`${interval} minutes`}</option>
      );
    }

    return options;
  };

  const renderConfigureStops = () => {
    let updatedAssignedStops = assignedStops.map((stop) => {
      let time = stop && stop.time && stop.time.toString();
      if (time === 0) {
        time = "0000";
      }
      if (time && time.length === 3) {
        time = "0" + time;
      }
      if (time && time.length === 2) {
        time = "00" + time;
      }
      return {
        ...stop,
        time: time,
      };
    });
    const daysOptions = Array.from(
      { length: journeyDays },
      (_, index) => index + 1
    );

    return (
      <div className="assignedServicesPanel">
        <h3 style={{ margin: "40px 0 16px 30px" }}>
          {assignedStops.length > 1 ? `${assignedStops.length} Rest Stops Added` : `${assignedStops.length} Rest Stop Added`}
        </h3>
        <div className="assignedListContainer">
          <div className="mainListContainer">
          {updatedAssignedStops &&
            updatedAssignedStops.map((item, index) => {
              return (
                <div key={index} >
                  <div className="assignedItem">
                    <div className="assignedTop">
                      <div className="assignedStopDetails">
                        <div className="assignedStopName">
                          {item.name || item.place_name}
                        </div>
                        <div className="assignedStopAddress">
                          {item.address || item.place_address}
                        </div>
                      </div>
                      <div className="assignedButtonContainer">
                        <div
                          className="deleteButton"
                          onClick={() => {
                            onDeleteClick(item);
                          }}
                        >
                          <img
                            src={deleteIcon}
                            alt="Delete"
                            className="delImage"
                          />
                          Delete
                        </div>
                        {(item.lat || item.latitude) &&
                          (item.long || item.longitude) && (
                            <div
                              className="mapButton"
                              onClick={() => {
                                onShowMapClick(item);
                              }}
                            >
                              <img
                                src={location}
                                alt="Location"
                                className="delImage"
                              />
                              Show in map
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="midLine"></div>
                    <div className="assignedBottom">
                      <div className="dayCont">
                        <div className="selectContainer">
                          {selectedDay !== "-1" && (
                            <label
                              className={selectedDay !== "-1" ? "selected" : ""}
                            >
                              Select Day
                            </label>
                          )}
                          <select
                            className="daySelect"
                            value={item.day || "-1"}
                            onChange={(e) =>
                              handleDayChange(item, e.target.value)
                            }
                          >
                            <option disabled value="-1">
                              Select Day
                            </option>
                            {daysOptions.map((day) => (
                              <option key={day} value={day}>
                                Day {day}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="timeCont">
                        <div className="selectContainer">
                          {selectedTime !== "-1" && (
                            <label
                              className={
                                selectedTime !== "-1" ? "selected" : ""
                              }
                            >
                              Select Time
                            </label>
                          )}
                          <select
                            className="timeSelect"
                            value={item.time || "-1"}
                            onChange={(e) =>
                              handleTimeChange(item, e.target.value)
                            }
                          >
                            <option disabled value="-1">
                              Select Time
                            </option>
                            {generateTimeOptions()}
                          </select>
                        </div>
                      </div>
                      <div className="durCont">
                        <div className="selectContainer">
                          {selectedDuration !== "-1" && (
                            <label
                              className={
                                selectedDuration !== "-1" ? "selected" : ""
                              }
                            >
                              Select Duration
                            </label>
                          )}
                          <select
                            className="durationSelect"
                            value={item.duration || "-1"}
                            onChange={(e) =>
                              handleDurationChange(item, e.target.value)
                            }
                          >
                            <option disabled value="-1">
                              Select Duration
                            </option>
                            {generateIntervalOptions()}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="bottomLast">
                      <img
                        src={infoIcon}
                        alt="Info Icon"
                        style={{ margin: "0px 8px 0 0" }}
                      />
                      Day 1 is date of departure
                    </div>
                  </div>
                </div>
              );
            })}
            </div>

          <div className="finalButtonContainer">
            {showSubmitButton && (
              <div
                className="finalSubmit"
                onClick={() => {
                  onSubmitClick();
                }}
              >
                Submit
              </div>
            )}
            <div
              className="addMore"
              onClick={() => {
                addMoreClicked();
              }}
            >
              Add more rest stops
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderNoRestStopAdded = (activeServiceId) => {
    const item = props.routeServices.find(
      (item) => item.id === activeServiceId
    );
    return item && item.rest_stops && !item.rest_stops.length ? (
      <div className="rightPanel">
        <h3>No Rest Stops Added</h3>
        <img src={NoRestStop} alt="No rest stop" className="noStopImage" />
        <div className="col-xs-7 addRestStop">
          <Button
            label="Add Rest Stop"
            onButtonClick={() => handleNoStopsClick()}
          />
        </div>
      </div>
    ) : null;
  };

  const handleNoStopsClick = () => {
    setShowRestStopHome(false);
    setShowRestStopAdd(true);
    let query = {
      src: sourceValue.city_id,
      dest: destinationValue.city_id,
    };
    props.fetchPopularStops(query);
  };

  const onSearchClick = () => {
    if (!sourceValue || !destinationValue) {
      alert("Please select a valid value of source and destination.");
      return;
    }
    localStorage.setItem("source", JSON.stringify(sourceValue));
    localStorage.setItem("destination", JSON.stringify(destinationValue));
    props.fetchServices({
      paytm_src_id: `${sourceValue.city_id}`,
      paytm_dest_id: `${destinationValue.city_id}`,
      is_round_trip: false,
      include_via_routes: false,
      rest_stops: true,
    });
  };
  return (
    <div onClick={closeAllInput} className="mainContainer">
      {showRestStopHome && (
        <>
          <div className="headerComponentHome">
            <div style={{ margin: "27px 0px 0px 15px" }} > 
              <h1>Rest Stops Configuration</h1>
              <h3>Enter Source and Destination</h3>
              <div className="inputContainer">
                <div className="inpContainer">
                  <StyledInput
                    type="text"
                    name="discountValue"
                    value={sourceValue.city_name}
                    onChange={setSourceCity}
                    placeholder="Enter Source"
                    errorMsg={""}
                    flag={true}
                  />
                  {sourceValue && !sourceValueSelected ? (
                    <ListView
                      cityList={props.cityData || []}
                      onSelect={(value) => {
                        setSourceValueSelected(true);
                        setSourceValue(value);
                      }}
                    />
                  ) : null}
                </div>
                {/* <div className="marginHorizontal" /> */}
                <div className="inpContainer">
                  <StyledInput
                    type="text"
                    name="discountValue"
                    value={destinationValue.city_name}
                    onChange={setDestinationCity}
                    placeholder="Enter Destination"
                    errorMsg={""}
                    flag={true}
                  />
                  {destinationValue && !destinationValueSelected ? (
                    <ListView
                      cityList={props.cityData || []}
                      onSelect={(value) => {
                        setDestinationValueSelected(true);
                        setDestinationValue(value);
                      }}
                    />
                  ) : null}
                </div>
                {/* <div className="marginHorizontal" /> */}
                <div className="col-xs-4">
                  <Button label="Search" onButtonClick={onSearchClick} />
                </div>
              </div>
            </div>
          </div>

          <div className="bodyContainer">
            {props.routeServices.length ? <RenderServiceList /> : null}
            {activeServiceId && renderNoRestStopAdded(activeServiceId)}
          </div>
        </>
      )}
      {showRestStopAdd && (
        <div className="headerComponentAdd">
          <AddRestStops
            popularRestStops={props.popularRestStops}
            getPickupPoints={props.getPickupPoints}
            placeSearchResults={props.placeSearchResults}
            assignedStops={assignedStops}
            setAssignedStops={setAssignedStops}
            setShowPostAssigned={setShowPostAssigned}
            setShowRestStopAdd={setShowRestStopAdd}
            setShowRestStopHome={setShowRestStopHome}
            mmiSignKey={props.mmiSignKey}
            sourceValue={sourceValue}
            destinationValue={destinationValue}
          />
        </div>
      )}
      {showPostAssigned && (
        <>
          <div className="headerComponentHome">
            <div style={{ margin: "27px 0px 0px 15px" }}>
              <h1>Rest Stops Configuration</h1>
              <h3>Enter Source and Destination</h3>
              <div className="inputContainer">
                <div className="inpContainer">
                  <StyledInput
                    type="text"
                    name="discountValue"
                    value={sourceValue.city_name}
                    onChange={setSourceCity}
                    placeholder="Enter Source"
                    errorMsg={""}
                    flag={true}
                  />
                  {sourceValue && !sourceValueSelected ? (
                    <ListView
                      cityList={props.cityData || []}
                      onSelect={(value) => {
                        setSourceValueSelected(true);
                        setSourceValue(value);
                      }}
                    />
                  ) : null}
                </div>
                {/* <div className="marginHorizontal" /> */}
                <div className="inpContainer">
                  <StyledInput
                    type="text"
                    name="discountValue"
                    value={destinationValue.city_name}
                    onChange={setDestinationCity}
                    placeholder="Enter Destination"
                    errorMsg={""}
                    flag={true}
                  />
                  {destinationValue && !destinationValueSelected ? (
                    <ListView
                      cityList={props.cityData || []}
                      onSelect={(value) => {
                        setDestinationValueSelected(true);
                        setDestinationValue(value);
                      }}
                    />
                  ) : null}
                </div>
                {/* <div className="marginHorizontal" /> */}
                <div className="col-xs-4">
                  <Button label="Search" onButtonClick={onSearchClick} />
                </div>
              </div>
            </div>
          </div>

          <div className="bodyContainer">
            {props.routeServices.length ? <RenderServiceList /> : null}
            {renderConfigureStops()}
          </div>
        </>
      )}
      {showSubmitPopup && (
        <Popup
          show={showSubmitPopup}
          onClose={() => setShowSubmitPopup(false)}
          onSubmit={onFinalSubmitClick}
          stops={assignedStops}
          src={sourceValue}
          dest={destinationValue}
        />
      )}
    </div>
  );
};

const mapStateToProps = (store) => ({
  cityData: store.citySearchAutoCompleteReducer.cityData,
  routeServices: store.dealsReducer.routeServices,
  popularRestStops: store.restStopsReducer.popularRestStops,
  placeSearchResults: store.restStopsReducer.placeSearchResults,
  mmiSignKey: store.restStopsReducer.mmiSignKey,
  assignStopSuccess: store.restStopsReducer.assignStopSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCities: (queryStr) => dispatch(fetchCities(queryStr)),
  fetchServices: (query) => dispatch(fetchServices(query)),
  fetchPopularStops: (query) => dispatch(fetchPopularStops(query)),
  getPickupPoints: (query) => dispatch(getPickupPoints(query)),
  getMMIKey: () => dispatch(getMMIKey()),
  assignRestStops: (payload) => dispatch(assignRestStops(payload)),
  deleteRestStop: (data) => dispatch(deleteRestStop(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCitiesAndService);
